import React from "react";
import { createUseStyles } from "react-jss";
import { AccordionItem } from "Components/Accordion";

import styles from "./styles";

interface PhotoMedia {
  id: number;
  url?: string;
  smallurl?: string;
  title?: string;
  description?: string;
  network?: string;
}

interface Props {
  photos: PhotoMedia[] | undefined;
  id: string;
  title: string;
}

// This component is used to display Photos and (Panoramas as images)
const ADADestinationPhotos = (props: Props) => {
  const { photos, id, title } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles();

  if (photos === undefined || photos.length === 0) {
    return null;
  }

  return (
    <AccordionItem id={id} title={title} headingLevel={4}>
      {photos.map((photo) => (
        <React.Fragment key={photo.id}>
          <h5 className={classes.photoHeading}>{photo.title}</h5>
          <figure className={classes.figure}>
            {photo.network === "instagram" ? (
              <iframe
                src={`https://www.instagram.com/p/${photo.url}/embed`}
                className={classes.instagramPhoto}
                frameBorder="0"
                scrolling="true"
                title={photo.title}
              />
            ) : (
              <img
                className={classes.photo}
                src={photo.smallurl}
                alt={photo.title}
              />
            )}
            {photo.description ? (
              <figcaption className={classes.photoDescription}>
                {photo.description}
              </figcaption>
            ) : null}
          </figure>
        </React.Fragment>
      ))}
    </AccordionItem>
  );
};

export default ADADestinationPhotos;
